import React from "react"

export default function mail() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-24"
      viewBox="0 0 132 99"
    >
      <defs />
      <path
        d="M6.8 5.9h117.7v88.3H6.8V5.9zM48.9 50L9.7 10.9v78.2L48.9 50zM11.8 8.8l51.8 51.8c.6.6 1.3.8 2.1.8s1.5-.3 2.1-.8l51.8-51.8H11.8zm68.6 43.3L69.9 62.6c-1.2 1.2-2.5 1.8-4.2 1.8s-3-.6-4.2-1.8L51 52.1 11.8 91.2h107.7L80.4 52.1zm2.1-2.1l39.1 39.1V10.9L82.5 50z"
        fill="#fff"
      />
    </svg>
  )
}
